//
// Sitewide JavaScript code, front-facing public site
//

// if an ACTIVE_NAV global is defined, find that item in the nav menu and tag is as .active so it gets alternate coloring
$(document).ready(function () {
    if (typeof ACTIVE_NAV !== 'undefined') {
        $('nav.navbar a[data-active="'+ACTIVE_NAV+'"]').addClass('active-nav');
    }
});
